export enum HeaderTable{
  titleForBrandTable = 'Brend',  
}

export enum HeaderColumns {
  brandname = 'Naziv',  
}

export enum ModalForAddOrUpdateBrand {
  titleForAddBrand = 'Dodavanje novog brenda',
  titleForUpdateBrand = 'Izmena naziva brenda',
  brandNameEmpty = 'Potrebno je uneti naziv brenda.',
  brandNamePlaceholder = 'Naziv',
  saveSuccessMessage = 'Nova rola je uspešno sačuvana.',
  updateSuccessMessage = 'Naziv role je uspešno izmenjen.',
  deleteSuccessMessage = 'Izabrana rola je uspešno obrisana.',
}



